export default __webpack_public_path__ + "static/img/internal3.dae238c.jpg";